import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setHandling(state, payload) {
    state.isHandling = payload;
  },
  setDetail(state, payload) {
    state.detail = payload;
  },
  setQuestionnaire(state, payload) {
    state.questionnaire = payload;
  },
};
